import React, { useEffect, useRef } from 'react';
import { toast } from 'react-toastify';

const SquareCardForm = React.memo(({ onCardReady }) => {
  const containerRef = useRef(null);
  const initializedRef = useRef(false);

  useEffect(() => {
    const containerElement = containerRef.current;

    async function initializeSquare() {
      if (initializedRef.current || !containerElement) return;

      try {
        const payments = await window.Square.payments(
          'sq0idp-r6HB_yWt7zl5CqiLe7CDhQ',
          'YK5H2TCW9GY9Q'
        );
        const card = await payments.card();
        await card.attach(containerElement);

        initializedRef.current = true;
        if (onCardReady) onCardReady(card);
        console.log('Square Card form initialized.');
      } catch (err) {
        console.error('Failed to load card form:', err);
        toast.error('Failed to initialize Square card form.');
      }
    }

    initializeSquare();

    return () => {
      if (containerElement) {
        containerElement.innerHTML = '';
      }
    };
  }, [onCardReady]);

  return <div ref={containerRef} id="square-card-container" className="mt-3" />;
});

export default SquareCardForm;
